export const formatPhoneNumber = (phoneNumber, fallback = "") => {
    if (phoneNumber == null || phoneNumber === "") return fallback;

    const digits = String(phoneNumber).replace(/\D/g, "");
    if (!digits) return fallback;

    const phoneDigits = digits.length > 10 ? digits.slice(-10) : digits;

    if (phoneDigits.length <= 3) return phoneDigits;
    if (phoneDigits.length <= 6) {
        return `(${phoneDigits.slice(0, 3)}) ${phoneDigits.slice(3)}`;
    }

    return `(${phoneDigits.slice(0, 3)}) ${phoneDigits.slice(
        3,
        6,
    )}-${phoneDigits.slice(6)}`;
};
